import React from "react";
import { useNavigate } from "react-router-dom";

const Gallery = () => {
  const navigate = useNavigate();
  const importAll = (r) => r.keys().map(r);
  const galleryImages = importAll(
    require.context("../assets/Gallery", false, /\.(jpe?g|png)$/i)
  );


  const wineIds = [
    "beetroot-wine",
    "black-grape-wine",
    "chikku-wine",
    "ginger-wine",
    "green-grape-wine",
    "jamun-wine",
    "raisins-wine",
    "mango-wine",
    "pineapple-wine",
    "rose-wine",
    "watermelon-wine",
    "white-jamun-wine",
    "dragon-fruit-wine",
    "mohua-wine"
  ];


  const prices = [
    "Rs 250", "Rs 450", "Rs 250", "Rs 450", "Rs 450", "Rs 800",
    "Rs 350", "Rs 250", "Rs 350", "Rs 700", "Rs 250", "Rs 350", "Dragon fruit wine launching shortly", "Mohua wine launching shortly", "Drinking good wine with good food in good company is one of life's most civilized pleasures.” ... Coming Soon" // Add more as needed, in image order
  ];

  return (
    <section className="bg-[--neutral-light-gray] py-24 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto space-y-20">
        {/* HEADER */}
        <div className="text-center space-y-5">
          <h1 className="text-4xl sm:text-5xl font-extrabold text-[--primary-wine] tracking-tight">
            Wine Moments Captured 🍷
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Explore timeless glimpses from our vineyards, cellars, and celebrations. Every photo celebrates our legacy and passion in winemaking.
          </p>
        </div>

        {/* GALLERY GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 place-items-center">
          {galleryImages.map((img, index) => (
            <div key={index} className="group transition duration-300 space-y-3 flex flex-col items-center">
              <div className="w-full h-[360px] flex items-center justify-center">
                <img
                  src={img}
                  alt={`Wine gallery ${index + 1}`}
                  className="max-h-full w-full object-contain group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <p className="text-center text-lg font-medium text-[--primary-wine] max-w-[280px] flex justify-center">
                {prices[index] || "Price on request"}
              </p>
              <button
                onClick={() => navigate(`/products?wine=${wineIds[index]}`)}
                className="mt-2 inline-block bg-[--primary-wine] text-white text-sm px-4 py-2 rounded hover:bg-[--primary-wine-hover] transition"
              >
                View Details
              </button>


            </div>
          ))}
        </div>

        {/* CTA BANNER */}
        <div className="bg-[--primary-wine] text-white text-center py-14 px-6 rounded-3xl shadow-2xl">
          <h2 className="text-3xl sm:text-4xl font-bold mb-3">Taste the Legacy</h2>
          <p className="text-base sm:text-lg max-w-xl mx-auto mb-6 text-gray-100">
            Visit us or place your order online — and experience the bold, handcrafted flavors passed down through generations.
          </p>
          <button className="bg-[--accent-gold] text-[--neutral-black] px-6 py-3 font-semibold rounded-md hover:bg-[--accent-gold-hover] transition" onClick={() => navigate("/products")}>
            Explore Our Wines
          </button>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
